import { Button, Typography } from "awantunai-design-system";
import HomeMenuItem from "components/menu/HomeMenuItem";
import { IHomeMenu } from "interfaces";
import MainStore from "store/MainStore";
import { runInAction, toJS } from "mobx";
import { observer } from 'mobx-react';
import { useParams } from "react-router";
import { Container } from '../../components/styleComponent/Container';
import Loading from "components/general/Loading";
import { ListManager } from 'react-beautiful-dnd-grid'

const HomeMenuView = () => {
    const { companyId, siteCode } = useParams();
    const loading = MainStore.loading;

    const onSave = () => {
        if (companyId && siteCode) {
            MainStore.updateMenus({
                homeMenu: toJS(MainStore.menus.homeMenu)
                    .filter((menu: any) => menu.name !== "" && menu.link !== ""),
                leftMenu: toJS(MainStore.menus.leftMenu)
            }, companyId, siteCode);
        }
    };

    const onChangeMenu = (e: any, index: number) => {
        MainStore.menus.homeMenu[index] = {
            ...MainStore.menus.homeMenu[index],
            [e.target.name]: e.target.value
        }
    };

    const onDelete = (index: number) => {
        const newMenus = [...MainStore.menus.homeMenu];
        let filterResult = newMenus.filter((menu, i) => i !== index);
        MainStore.menus.homeMenu = filterResult;
    };

    const onAdd = () => {
        const newMenus = [...MainStore.menus.homeMenu];
        newMenus.push({
            name: "",
            link: "",
            type: "external",
            description: "",
            image: ""
        });
        runInAction(() => {
            MainStore.menus.homeMenu = newMenus;
        });
    };

    const onExportFile = () => {
        const data = JSON.stringify(MainStore.menus.homeMenu);
        const blob = new Blob([data], { type: "application/json" });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.setAttribute("href", url);
        a.setAttribute("download", `${companyId}_${siteCode}_homeMenu.json`);
        a.click();
    }

    const onImportFile = () => {
        const input = document.createElement("input");
        input.type = "file";
        input.accept = ".json";
        input.onchange = async (e: any) => {
            const file = e.target.files[0];
            if (file) {
                const text = await file.text();
                const data = JSON.parse(text);
                MainStore.menus.homeMenu = data;
            }
        }
        input.click();
    }
    
    const reorderList = (sourceIndex: number, destinationIndex: number) => {
        if (sourceIndex === destinationIndex) return
        const sourceItem = MainStore.menus.homeMenu[sourceIndex]
        MainStore.menus.homeMenu.splice(sourceIndex, 1)
        MainStore.menus.homeMenu.splice(destinationIndex, 0, sourceItem)
    }

    return (
        <Container>
            <Typography variant="h4" mb={15}>Home menus</Typography>
            <div className="scroll-view">
                <div className={"section"}>
                    {MainStore.menus.homeMenu ?
                        <ListManager
                            items={MainStore.menus.homeMenu.map((_menu: IHomeMenu, index) => index)}
                            direction="horizontal"
                            maxItems={4}
                            render={(index) => <HomeMenuItem
                                data={MainStore.menus.homeMenu[index]}
                                id={index}
                                onChange={(m: any) => onChangeMenu(m, index)}
                                onDelete={() => onDelete(index)}
                            />}
                            onDragEnd={reorderList}
                        />
                        :
                        <>No datas</>}
                    <Button
                        title="Add"
                        onClick={onAdd}
                        size="small"
                        icon="AddOne"
                        variant="secondary"
                        style={{ width: 100, margin: 10 }}
                    />
                </div>
            </div>
            <div>
                <Button
                    title="Save"
                    onClick={onSave}
                    size="small"
                    icon="SaveOne"
                    variant="primary"
                    style={loading ? { display: 'none' } : { width: 100, marginLeft: 20, marginTop: 20, display: "inline-flex" }}
                />
                <Button
                    title="Import File"
                    onClick={onImportFile}
                    size="small"
                    icon="Upload"
                    variant="primary"
                    style={loading ? { display: 'none' } : { width: 120, marginLeft: 20, marginTop: 20, display: "inline-flex" }}
                />
                <Button
                    title="Export File"
                    onClick={onExportFile}
                    size="small"
                    icon="Download"
                    variant="primary"
                    style={loading ? { display: 'none' } : { width: 120, marginLeft: 20, marginTop: 20, display: "inline-flex" }}
                />
            </div>
            <Loading isloading={loading} />
        </Container>
    );
};

export default observer(HomeMenuView);


